import { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

interface HeadingLabeledValueCardProps {
    title: string;
    content: string;
}

const HeadingLabeledValueCard: FC<HeadingLabeledValueCardProps> = ({ title, content }) => {
    const theme = useTheme();
    const cardStyles = {
        border: `1px solid ${theme.palette.orange.light}`,
        borderColor: `${theme.palette.orange.light}`,
        borderRadius: 3,
        width: '100%',
    };

    return (
        <Box display="flex" sx={cardStyles}>
            <Typography
                minHeight={'100%'}
                variant="subtitle2"
                p={2}
                fontWeight={600}
                fontSize="20px"
                lineHeight="24px"
                sx={{
                    color: `${theme.palette.common.white}`,
                    fontWeight: 'bold',
                    backgroundColor: `${theme.palette.orange.main}`,
                    height: '100%',
                    borderRadius: '8px 0 0 8px',
                    width: '40%',
                    alignContent: 'center',
                }}
            >
                {title}
            </Typography>
            <Typography
                variant="subtitle2"
                p={2}
                fontWeight={500}
                fontSize="20px"
                lineHeight="24px"
                sx={{
                    color: theme.palette.grey.primary,
                    alignContent: 'center',
                    width: '100%',
                }}
            >
                {content}
            </Typography>
        </Box>
    );
};

export default HeadingLabeledValueCard;
